import React from 'react'
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'
import 'animate.css/animate.css'
import 'font-awesome/css/font-awesome.css'
import './gatstrap.scss'

export default function Template ({ children }) {
  return (
    <div>
      <NavBar />
      { children }
      <Footer />
    </div>
  )
}
